import Icon, { Props as IconProps } from "@ternary/web-ui-lib/components/Icon";
import React from "react";

export default function IconAlibabaCloud(props: IconProps): React.JSX.Element {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-22.98 -3.25 64 64"
        fill="#ff6b01"
      >
        <path d="M-14.278 9.1c-2.917.6-6.05 2.93-7.352 5.484s-1.35 3.182-1.35 13.933c0 5.737.096 10.462.24 11.2.856 4.376 4.278 7.798 8.654 8.654 1.326.24 18.585.362 18.585.096 0-.193-1.47-5.978-1.543-6.05-.024-.048-3.086-.723-6.798-1.52-8.654-1.88-8.4-1.808-9.112-2.676l-.627-.747v-17.5l.627-.76c.723-.868.458-.795 9.112-2.676l6.798-1.52C3.03 14.968 4.5 9.182 4.5 9c0-.23-17.62-.12-18.778.12zm27.938.036c.024.434 1.374 5.737 1.52 5.882.048.072 3.35.82 7.304 1.663s7.473 1.7 7.786 1.88c.424.246.78.594 1.037 1.012.386.675.434 1.398.434 9.16s-.048 8.485-.434 9.16a3.17 3.17 0 0 1-1.037 1.012c-.313.17-3.8 1.012-7.786 1.88L15.18 42.46c-.145.145-1.495 5.448-1.52 5.882 0 .265 1.736.313 9.353.24 10.5-.096 10.63-.12 13.306-1.928 1.922-1.323 3.374-3.222 4.146-5.424.554-1.615.554-1.76.554-12.487s0-10.872-.554-12.487a11.01 11.01 0 0 0-4.146-5.424C33.643 9.026 33.523 9 23.013 8.905c-7.617-.072-9.353-.036-9.353.24zM2.9 28.238a1.74 1.74 0 0 0-.048.795c.072.4.506.434 6.17.506l6.075.048V27.9H9.08c-5.038 0-6.075.048-6.17.337z" />
      </svg>
    </Icon>
  );
}
